import {Observable, Subject} from 'rxjs';
import {Constructor, EventContext} from '../common/types';

type BusEvent = {event: Constructor<any>, args: any, context: EventContext};

class EventBusImpl {
	private readonly bus$ = new Subject<BusEvent>();

	public get eventsBus$(): Observable<BusEvent> {
		return this.bus$.asObservable();
	}

	public dispatch = <T>(event: Constructor<T>, args: T): void => {
		this.bus$.next({event, args, context: {source: 'this', crossTab: false}});
	};
}

export const EventBus = new EventBusImpl();
